import { render, staticRenderFns } from "./SaleIndex.vue?vue&type=template&id=1ee39088&scoped=true&"
import script from "./SaleIndex.vue?vue&type=script&lang=js&"
export * from "./SaleIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee39088",
  null
  
)

export default component.exports